import {ImagePreview as PeacockImagePreview} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ImagePriviewProps} ImagePreviewProps
 * @property {string} src Image URL to preview.
 * @property {string} [placeholder] Fallback image URL.
 * @property {import('@pepsico-ds/ui').TransformOrigin} [transformOrigin] Transform origin for zoom operations. Defaults to 'center'.
 * @property {boolean} [showRotateControls] Shows rotation controls. Defaults to true.
 * @property {boolean} [showFlipControl] Shows the flip control. Defaults to true.
 * @property {boolean} [showDownloadControl] Shows the download control. Defaults to true.
 * @property {boolean} [showPrintControl] Shows the print control. Defaults to true.
 * @property {boolean} [showZoomControls] Shows zoom controls. Defaults to true.
 * @property {(zoomScale: number) => void} [onZoomIn] Callback when the zoom-in value changes.
 * @property {(zoomScale: number) => void} [onZoomOut] Callback when the zoom-out value changes.
 * @property {(rotationAngle: number) => void} [onRotateLeft] Callback when the image rotates left.
 * @property {(rotationAngle: number) => void} [onRotateRight] Callback when the image rotates right.
 * @property {(flipped: boolean) => void} [onFlip] Callback when the image is flipped.
 * @property {(downloadedImageName: string) => void} [onDownload] Callback when the image is downloaded.
 * @property {string} [width] Width of the image preview container.
 * @property {string} [height] Height of the image preview container. Defaults to '80vh'.
 * @property {string} [className] Additional CSS class names.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS ImagePreview.
 * Supports all Peacock DS image preview props and inherited HTML attributes.
 * @param {ImagePreviewProps} props
 */
export const ImagePreview = ({className, ...props}) => {
	return <PeacockImagePreview className={`custom-image-preview${className ? ` ${className}` : ''}`} {...props} />
}
